import { baseUrl } from "../../../shared/config";
import { parseEventMoments } from "./parseEventMoments";

export const parseCheckInEvent = (live) => {
  var eventType,
    eventId,
    contentType,
    contentURL,
    foo,
    sharableURL = "";
  foo = live.tipo?.toUpperCase() || live.TIPO?.toUpperCase();
  contentURL =
    live.link_meeting ||
    live.live_codigo_embed ||
    live.link ||
    live.link_meeting;
  if (
    live.link_meeting ||
    contentURL?.includes("meet.google.com") ||
    foo?.includes("MEETING") ||
    foo?.includes("TEAMS")
  ) {
    contentType = "external";
  } else if (foo?.includes("PRESENCIAL")) {
    contentType = "presencial";
    contentURL = ".fakeurl";
  } else if (foo?.includes("ZOOM")) {
    contentType = "zoom";
  } else if (contentURL?.includes("panda")) {
    contentType = "video";
  } else {
    contentType = "embedded";
  }

  //
  if (!(live.liveid || live.LIVEID)) {
    if (live.sessaoid) {
      eventType = "sessao";
    } else {
      eventType = "aula";
    }
  } else {
    eventType = "live";
  }
  eventId = live.liveid || live.LIVEID || live.aulaid || live.sessaoid;
  //

  sharableURL = `${baseUrl}/aluno/checkin/${eventType}/${eventId}/${contentType}
  `;
  if (!eventId) {
    sharableURL = live.link;
  }
  //
  const eventMoments = parseEventMoments(live);
  return {
    eventType,
    eventId,
    contentType,
    contentURL,
    sharableURL,
    eventMoments,
    canBeAccessedNow:
      eventMoments.checkInIsHappening ||
      eventMoments.eventIsHappening ||
      ((eventMoments.checkInHasEnded || eventMoments.eventHasEnded) &&
        live.permite_rever === "S"),
  };
};
